

import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import { EVENT } from '../../../common/events/listEvents';

@translate([], {wait: true})
@inject('BetslipStore')
@observer
class PopUpModalComponent extends Component {

  constructor(props) {
    super(props);

    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);

    this.state = {
      message: '',
      show: false,
    }
  }

  componentDidMount() {
    window.listenEvent(EVENT.OPEN_POPUP_MODAL, this.openPopup);
    window.listenEvent(EVENT.CLOSE_POPUP_MODAL, this.closePopup);
    window.listenEvent(EVENT.OPEN_POPUP_WITH_CANCEL_MODAL, this.openPopupWithCancel);
  }

  componentWillUnmount() {
    window.stopListenEvent(EVENT.OPEN_POPUP_MODAL, this.openPopup);
    window.stopListenEvent(EVENT.OPEN_POPUP_WITH_CANCEL_MODAL, this.openPopupWithCancel);
    window.stopListenEvent(EVENT.CLOSE_POPUP_MODAL, this.closePopup);
  }


  openPopup() {
    const popUpComp = window.popUpModalComp;
    if (popUpComp) {
      this.setState({
        show: true,
        message: popUpComp.message,
        yesAction: popUpComp.yesAction,
        showNoAction: popUpComp.showNoAction,
      })
    }
    window.popUpModalComp = {};
  }

  openPopupWithCancel = () => {
    const popUpComp = window.popUpModalComp;
    if (popUpComp) {
      this.setState({
        show: true,
        message: popUpComp.message,
        yesAction: popUpComp.yesAction,
        noAction: popUpComp.noAction,
        showNoAction: popUpComp.showNoAction,
      })
    }
    window.popUpModalComp = {};
  }
  
  openPopupWithCancel = () => {
    const popUpComp = window.popUpModalComp;
    if (popUpComp) {
      this.setState({
        show: true,
        message: popUpComp.message,
        yesAction: popUpComp.yesAction,
        noAction: popUpComp.noAction,
        showNoAction: popUpComp.showNoAction,
      })
    }
    window.popUpModalComp = {};
  }

  closePopup() {
    if (this.props.BetslipStore.checkDisableInputStake) {
      this.props.BetslipStore.disableInputStake(false);
    }

    this.setState({
      show: false,
      message: '',
      yesAction: null,
      noAction: null,
      showNoAction: false
    })
  }
  
  closePopupWithCancel = (noAction) => {
    if (this.props.BetslipStore.checkDisableInputStake) {
      this.props.BetslipStore.disableInputStake(false);
    }

    if (noAction) {
      noAction()
    }

    this.setState({
      show: false,
      message: '',
      yesAction: null,
      noAction: null,
      showNoAction: false
    })
  }

  render() {
    const {
      message,
      showNoAction,
      yesAction,
      noAction
    } = this.state;
    return(
      <React.Fragment>
        {
          this.state.show
          ?
          <div className="popup-modal-overlay" id="popUpConfirm">
              <div className={"popup-modal-component"}>
                <div className="popup-modal-message">
                  <div dangerouslySetInnerHTML={{ __html: message }}></div>
                </div>
                <div className="popup-modal-actions">
                  {
                    showNoAction
                    ?  <span>
                            <Button className="cancel-btn" onClick={() => this.closePopupWithCancel(noAction)}>{this.props.t('Cancel')}</Button>
                        </span>
                    : null
                  }
                  <span>
                    <Button className="yes-btn" onClick={yesAction}>{this.props.t('Yes')}</Button>
                  </span>
                </div>
            </div>
          </div>
          : null
        }
        
      </React.Fragment>
        
    )
  }
  
}
export default PopUpModalComponent;


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/PopUpModalComponent/index.js